import {
    ESHOP_BANNER_TEXT,
    PREGNANCY_NEWSLETTER_BANNER_TEXT, PREGNANCY_NEWSLETTER_HINT,
    PRODUCT_ESHOP_BADGE,
} from 'mk/autogenerated/translations/HomeBaseBannerComponent.d4851c861702d8a91512fc79d3310573'
import { ACTIVE_SERVER_ID, BASE_URL, ESHOP_URL } from 'mk/settings';
import HomeBaseBanner from 'mk2/apps/home/components/HomeBaseBanner';
import { UserEntity } from 'mk2/schemas';
import React from 'react';


interface OwnProps {
    className?: string;
    requestUser?: UserEntity;
    showEshopHome?: boolean;
    showPregnancyNl?: boolean;
}

type Props = OwnProps;

const HomeBaseBannerComponent = React.memo<Props>(({
    className,
    requestUser,
    showEshopHome= true,
    showPregnancyNl= true,
}) => {

    const eshopHomeLink = {
        201: `${ESHOP_URL}?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=eshop`,
        202: `${ESHOP_URL}?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=eshop`,
    }[ACTIVE_SERVER_ID];

    const pregnancyNLLink = {
        201: `${BASE_URL}/som-tehotna/newsletter-pre-tehotne/?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=newsletter`,
        202: `${BASE_URL}/jsem-tehotna/newsletter-pro-tehotne/?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=newsletter`,
    }[ACTIVE_SERVER_ID];


    return (
    <>
        {showEshopHome &&
            <HomeBaseBanner
                className={className}
                linkTo={eshopHomeLink}
                hintText={PRODUCT_ESHOP_BADGE}
                text={ESHOP_BANNER_TEXT}
            />
        }
        {showPregnancyNl &&
            <HomeBaseBanner
                className={className}
                linkTo={pregnancyNLLink}
                text={PREGNANCY_NEWSLETTER_BANNER_TEXT}
                hintText={PREGNANCY_NEWSLETTER_HINT}
            />
        }
    </>
    );
});

HomeBaseBannerComponent.displayName = 'HomeBaseBannerComponent';

export default HomeBaseBannerComponent;
